// extracted by css-extract-rspack-plugin
export default {"upgradeLink":"upgradeLink-cfyrbU"};